import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { TableModule } from 'primeng/table';
import { CPFMaskDirective } from './directives/cpf-mask.directive';
import { MaiusculoMinusculoDirective } from './directives/maiusculo-minusculo.directive';
import { TelefoneMaskDirective } from './directives/telefone-mask.directive';
import { TiposCredenciaisLoginAcessoDirective } from './directives/tipos-credenciais-login-acesso.directive';
import { TrocarValorSimNaoDirective } from './directives/troca-valor-sim-nao.directive';
import { VerificarCapsUpDirective } from './directives/verificar-caps-up.directive';
import { FormDebugComponent } from './forms/form-debug/form-debug.component';
import { AtualizarEmailFoneComponent } from './layout/atualizar-email-fone/atualizar-email-fone.component';
import { PanelGenericoComponent } from './layout/body-fieldset/panel-generico.component';
import { BotaoFlutuanteVoltarCardsComponent } from './layout/botao-flutuante-voltar-cards/botao-flutuante-voltar-cards.component';
import { BotaoFlutuanteVoltarComponent } from './layout/botao-flutuante-voltar/botao-flutuante-voltar.component';
import { CardComponent } from './layout/card/card.component';
import { HeaderInicialComponent } from './layout/header-inicial/header-inicial.component';
import { HeaderTopComponent } from './layout/header-top/header-top.component';
import { MenuLateralParaleloComponent } from './layout/menu-lateral/menu-lateral-paralelo.component';
import { AppMenuLateralSubComponent } from './layout/menu-lateral/menu-lateral-sub/menu-lateral-sub.component';
import { PageConfirmarMatriculaComponent } from './layout/page-confirmar-matricula/page-confirmar-matricula.component';
import { ActivePendenciaPipe } from './pipe/active-pendencia.pipe';
import { AlternativaSimNaoPipe } from './pipe/alternativa-sim-nao.pipe';
import { AtivoInativoPipe } from './pipe/ativo-inativo.pipe';
import { AtivoPipe } from './pipe/ativo.pipe';
import { CategoriaPipe } from './pipe/categoria.pipe';
import { CepPipe } from './pipe/cep.pipe';
import { CnpjPipe } from './pipe/cnpj-pipe';
import { CpfCnpjPipe } from './pipe/cpf-cnpj.pipe';
import { CpfEmailMatriculaPipe } from './pipe/cpf-email-matricula.pipe';
import { CpfPipe } from './pipe/cpf-pipe';
import { DecimalAreaRestritaPipe } from './pipe/decimal.pipe';
import { FormateNumberZeroPipe } from './pipe/format-number-zero.pipe';
import { MatriculaPipe } from './pipe/matricula.pipe';
import { MesPipe } from './pipe/mes.pipe';
import { MesesPipe } from './pipe/meses.pipe';
import { ParentescoPipe } from './pipe/parentesco.pipe';
import { PatrocinadoraOrigemPipe } from './pipe/patrocinadora-origem.pipe';
import { PorcentagemPipe } from './pipe/porcentagem.pipe';
import { SexoPipe } from './pipe/sexo.pipe';
import { SimNaoPipe } from './pipe/sim-nao.pipe';
import { StatusPipe } from './pipe/status.pipe';
import { TelPipe } from './pipe/tel.pipe';
import { TelefoneEmailPipe } from './pipe/telefone-email.pipe';
import { TelefonePipe } from './pipe/telefone.pipe';
import { ValorContratoPipe } from './pipe/valor-contrato.pipe';
import { ValorProcorPipe } from './pipe/valor-procor.pipe';
import { ValorPipe } from './pipe/valor.pipe';
import { CanDeactivateGuard } from './services/can-deactivate-guard.service';
import { ContrachqueAposentadoPdf } from './services/documentos-pdf-imprimir/financeiro/contracheques/contracheque-aposentados-pdf';
import { ContrachqueFuncionarioPdf } from './services/documentos-pdf-imprimir/financeiro/contracheques/contracheque-funcionario-pdf';
import { DeclaracaoRendimentoDetalhePdf } from './services/documentos-pdf-imprimir/financeiro/declaracao-redimento/declaracao-rendimento-detalhe-pdf';
import { DeclaracaoRendimentoPdf } from './services/documentos-pdf-imprimir/financeiro/declaracao-redimento/declaracao-rendimento-pdf';
import { DeclaracaoRendEmpFinDetalhePdf } from './services/documentos-pdf-imprimir/financeiro/declaracao-rend-emp-fin/declaracao-rend-emp-fin-detalhe-pdf';
import { IrPatrimonialDetalhePdf } from './services/documentos-pdf-imprimir/financeiro/ir-patrimonial/ir-patrimonial-detalhe-pdf';
import { IrPatrimonialPdf } from './services/documentos-pdf-imprimir/financeiro/ir-patrimonial/ir-patrimonial-pdf';
import { SEFSaldoFinanciamentoPdf } from './services/documentos-pdf-imprimir/financeiro/SEF/sef-saldo-financiamento-pdf';
import { BPDPdf } from './services/documentos-pdf-imprimir/Plano/beneficio-proprio-diferido/bpd-pdf';
import { DR2008Pdf } from './services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2008-pdf';
import { DR2008CompPdf } from './services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2008Comp-pdf';
import { DR2009Pdf } from './services/documentos-pdf-imprimir/Plano/destinacao-reserva/dr2009-pdf';
import { DRMaiorOrIgual2012Pdf } from './services/documentos-pdf-imprimir/Plano/destinacao-reserva/drMaiorOrIgual2012-pdf';
import { FPCConsultaFracaoPatrimonialPdf } from './services/documentos-pdf-imprimir/Plano/fpc/fpc-consulta-fracao-patrimonial-pdf';
import { FPCReservaPreviPdf } from './services/documentos-pdf-imprimir/Plano/fpc/fpc-reserva-previ-pdf';
import { PBDCBeneficioPdf } from './services/documentos-pdf-imprimir/Plano/pbdc/pbdc-beneficio-pdf';
import { PBDCFundoPrevidencialPdf } from './services/documentos-pdf-imprimir/Plano/pbdc/pbdc-fundo-previdencial-pdf';
import { PBDCReservaPoupancaPdf } from './services/documentos-pdf-imprimir/Plano/pbdc/pbdc-reserva-poupanca-pdf copy';
import { PBDCSuperavitPdf } from './services/documentos-pdf-imprimir/Plano/pbdc/pbdc-superavit-pdf';
import { EnderecoCadastroService } from './services/endereco-cadastro.service';
import { EnderecoCentrusService } from './services/endereco-centrus.service';
import { FilterDefaultService } from './services/filter-default.service';
import { PermissaoModulosService } from './services/permissoes-modulos.service ';
import { PessoaService } from './services/pessoa.service';
import { ValidarPermissaoFuncionalidadeService } from './services/validar-permissao-funcionalidades.service';
import { DateUtilService } from './util/date-util.service';
import { FuncoesCardMenu } from './util/funcaoes-card-menu/funcoes-card-menu';
import { SharedCentrusAtualizadaModule } from './util/shared-centrus-atualizada.module';
import { UtilService } from './util/util.service';
import { PageEscolherMatriculaEmprestimoComponent } from './layout/page-escolher-matricula-emprestimo/page-escolher-matricula-emprestimo.component';
import { LayoutPutasReuniaoComponent } from './layout/layout-putas-reuniao/layout-putas-reuniao.component';
import { PageEscolherMatriculaEleicaoComponent } from './layout/page-escolher-matricula-eleicao/page-escolher-matricula-eleicao.component';
// import { CentrusModule, SharedCentrusAtualizadaModule } from 'front-end-components';
// import { BodyFieldsetComponent } from './layout/body-fieldset/body-fieldset.component';
// shared.centrus.module

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    CurrencyMaskModule,
    SharedCentrusAtualizadaModule

  ],
  declarations: [
    FormDebugComponent,
    CnpjPipe,
    TelPipe,
    FormateNumberZeroPipe,
    ValorPipe,
    CpfPipe,
    MesPipe,
    PatrocinadoraOrigemPipe,
    ActivePendenciaPipe,
    AtivoPipe,
    AtivoInativoPipe,
    CepPipe,
    PorcentagemPipe,
    CpfCnpjPipe,
    TelefoneEmailPipe,
    SexoPipe,
    CategoriaPipe,
    DecimalAreaRestritaPipe,
    StatusPipe,
    ParentescoPipe,
    MesesPipe,
    SimNaoPipe,
    AlternativaSimNaoPipe,
    ValorContratoPipe,
    TelefonePipe,
    ValorProcorPipe,
    MatriculaPipe,
    CpfEmailMatriculaPipe,
    BotaoFlutuanteVoltarComponent,
    LayoutPutasReuniaoComponent,
    BotaoFlutuanteVoltarCardsComponent,
    MenuLateralParaleloComponent,
    AppMenuLateralSubComponent,
    CardComponent,
    HeaderTopComponent,
    TrocarValorSimNaoDirective,
    MaiusculoMinusculoDirective,
    VerificarCapsUpDirective,
    TiposCredenciaisLoginAcessoDirective,
    HeaderInicialComponent,
    CPFMaskDirective,
    TelefoneMaskDirective,
    PanelGenericoComponent,
    AtualizarEmailFoneComponent,
    PageConfirmarMatriculaComponent,
    PageEscolherMatriculaEmprestimoComponent,
    LayoutPutasReuniaoComponent,
    PageEscolherMatriculaEleicaoComponent
  ],
  exports: [
    CpfEmailMatriculaPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormDebugComponent,
    CnpjPipe,
    TelPipe,
    FormateNumberZeroPipe,
    ValorPipe,
    CpfPipe,
    MesPipe,
    PatrocinadoraOrigemPipe,
    TableModule,
    CepPipe,
    PorcentagemPipe,
    CpfCnpjPipe,
    TelefoneEmailPipe,
    SexoPipe,
    CategoriaPipe,
    DecimalAreaRestritaPipe,
    StatusPipe,
    ParentescoPipe,
    SimNaoPipe,
    AlternativaSimNaoPipe,
    ValorContratoPipe,
    TelefonePipe,
    ValorProcorPipe,
    MatriculaPipe,
    AtivoPipe,
    RecaptchaModule,
    MesesPipe,
    CurrencyMaskModule,
    BotaoFlutuanteVoltarComponent,
    LayoutPutasReuniaoComponent,
    BotaoFlutuanteVoltarCardsComponent,
    MenuLateralParaleloComponent,
    CardComponent,
    HeaderTopComponent,
    TrocarValorSimNaoDirective,
    MaiusculoMinusculoDirective,
    VerificarCapsUpDirective,
    TiposCredenciaisLoginAcessoDirective,
    HeaderInicialComponent,
    CPFMaskDirective,
    TelefoneMaskDirective,
    PanelGenericoComponent,
    AtualizarEmailFoneComponent,
    SharedCentrusAtualizadaModule
  ],
  providers: [
    UtilService,
    DateUtilService,
    EnderecoCadastroService,
    CanDeactivateGuard,
    ContrachqueFuncionarioPdf,
    DeclaracaoRendimentoPdf,
    DeclaracaoRendEmpFinDetalhePdf,
    DeclaracaoRendimentoDetalhePdf,
    PessoaService,
    IrPatrimonialPdf,
    IrPatrimonialDetalhePdf,
    SEFSaldoFinanciamentoPdf,
    PBDCBeneficioPdf,
    PBDCFundoPrevidencialPdf,
    PBDCReservaPoupancaPdf,
    PBDCSuperavitPdf,
    FPCConsultaFracaoPatrimonialPdf,
    FPCReservaPreviPdf,
    FuncoesCardMenu,
    BPDPdf,
    DR2008Pdf,
    DR2008CompPdf,
    DR2009Pdf,
    DRMaiorOrIgual2012Pdf,
    ContrachqueAposentadoPdf,
    FilterDefaultService,
    ValidarPermissaoFuncionalidadeService,
    PermissaoModulosService,
    EnderecoCentrusService
  ]
})
export class AreaRestritaSharedModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/area-restitra.shared.module.ts